import {
  IParamMapper,
  ISimpleCRUDServiceFactory
} from "../../../service/SimpleCRUDServiceFactory";
import { RequestArgs } from "../../../service/HttpService";

export default class DeleteListResourceInteractor<T> {
  private serviceFactory: ISimpleCRUDServiceFactory<T>;

  constructor({ simpleCRUDServiceFactory }: any) {
    this.serviceFactory = simpleCRUDServiceFactory;
  }

  async execute(
    basePath: string,
    model: T[],
    args?: RequestArgs,
    ParamMapper?: IParamMapper<T>
  ) {
    const result = await this.serviceFactory
      .create({
        basePath,
        ParamMapper
      })
      .deleteListResource(model, args);
    return result;
  }
}
